import { cloneDeep } from 'lodash-es'
import { OperationSpec } from '../models/OperationContext'
import { RunnableFileCopy } from '../models/RunnableFileCopy'
import { RunnableFileDelete } from '../models/RunnableFileDelete'
import { RunnableFileDownload } from '../models/RunnableFileDownload'
import { RunnableFileUpload } from '../models/RunnableFileUpload'
import { RunnableInboxDownload } from '../models/RunnableInboxDownload'
import { RunnableFolderPut } from '../models/RunnableFolderPut'
import { RunnableOperation } from '../models/RunnableOperation'
import { RunnablePasswordDelete } from '../models/RunnablePasswordDelete'
import { RunnablePasswordPut } from '../models/RunnablePasswordPut'
import { RunnablePasswordUpdate } from '../models/RunnablePasswordUpdate'

export class OperationCompiler {
  compile(spec: OperationSpec): RunnableOperation[] {
    switch (spec.type) {
      case 'password.put':
        return [new RunnablePasswordPut(spec)]

      case 'password.update':
        return [new RunnablePasswordUpdate(spec)]

      case 'password.delete':
        return [new RunnablePasswordDelete(spec)]

      case 'file.upload':
        return [new RunnableFileUpload(spec)]

      case 'file.delete':
      case 'folder.delete':
        return [new RunnableFileDelete(spec)]

      case 'file.download':
        return [new RunnableFileDownload(spec)]

      case 'inbox.download':
        return [new RunnableInboxDownload(spec)]

      case 'folder.put':
        return [new RunnableFolderPut(spec)]

      case 'file.update':
      case 'file.move':
        const deleteFileSpec = {
          ...cloneDeep(spec),
          to: undefined,
          type: 'file.delete',
        } as OperationSpec
        return [
          new RunnableFileCopy(spec),
          new RunnableFileDelete(deleteFileSpec),
        ]

      case 'folder.update':
      case 'folder.move':
        const deleteFolderSpec = {
          ...cloneDeep(spec),
          to: undefined,
          type: 'folder.delete',
        } as OperationSpec
        return [
          new RunnableFolderPut(spec),
          new RunnableFileDelete(deleteFolderSpec),
        ]

      default:
        throw new Error(`Tipo di operazione sconosciuto: ${spec.type}`)
    }
  }
}
